module.exports = __webpack_public_path__ + "static/media/18ECA21.2bb8f47b.jpg";